// Build a Supabase-storage image URL with on-the-fly transforms.
// Falls back to the original URL for any non-Supabase host.
const SUPABASE_OBJECT = "/storage/v1/object/public/";
const SUPABASE_RENDER = "/storage/v1/render/image/public/";

type TransformOpts = {
  width?: number;
  height?: number;
  quality?: number;
  resize?: "cover" | "contain" | "fill";
  /** Output format. Defaults to "webp" for smaller payloads. */
  format?: "webp" | "jpeg" | "png" | "origin";
};

export function transformedImage(url: string, opts: TransformOpts = {}): string {
  if (!url) return url;
  try {
    const u = new URL(url, typeof window === "undefined" ? "http://x" : window.location.origin);
    if (!u.pathname.includes(SUPABASE_OBJECT)) return url;
    u.pathname = u.pathname.replace(SUPABASE_OBJECT, SUPABASE_RENDER);
    if (opts.width) u.searchParams.set("width", String(opts.width));
    if (opts.height) u.searchParams.set("height", String(opts.height));
    u.searchParams.set("quality", String(opts.quality ?? 75));
    if (opts.resize) u.searchParams.set("resize", opts.resize);
    u.searchParams.set("format", opts.format ?? "webp");
    return u.toString();
  } catch {
    return url;
  }
}

export function buildSrcSet(
  url: string,
  widths: number[],
  opts: Omit<TransformOpts, "width"> = {},
): string | undefined {
  if (!url || !url.includes(SUPABASE_OBJECT)) return undefined;
  return widths
    .map((w) => `${transformedImage(url, { ...opts, width: w })} ${w}w`)
    .join(", ");
}
